import type { IconData } from '@stacksjs/iconify-core'

export const scissors: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M21 13a8.98 8.98 0 0 1-3.312 6.975S32.154 11 38 11c4.312 0 6.486 2.513 7.367 3.926c.305.489.036 1.084-.511 1.263C41.862 17.167 32.666 20.252 24 24c8.666 3.748 17.862 6.833 20.856 7.811c.547.179.816.774.511 1.263C44.486 34.487 42.312 37 38 37c-5.846 0-20.312-8.975-20.312-8.975a9 9 0 1 1-10.943-.332c1.187-.969 3.139-2.262 5.505-3.693c-2.366-1.431-4.318-2.724-5.506-3.693A9 9 0 1 1 21 13m-9 3a3 3 0 1 0 0-6a3 3 0 0 0 0 6m0 16a3 3 0 1 1 0 6a3 3 0 0 1 0-6\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default scissors
